export class DocumentAttributeValue {
    DocumentAttributeId: number;
    Name: string;
    Description: string;
    DocumentDatatypeId: number;
    DocumentDatatypeName: string;
    Value: string;
    DocumentId: number;
}
